import { Badge, Flex, Text } from '@tradener/lumen';

import { resolveRatingLabel } from './NineBoxTableRows';
import { NineBoxRatingProps } from './mockData';
import { NineBoxCellSelectionProps } from './types';

interface NineBoxActiveFiltersProps {
  consideredPeriodLabel?: string;
  hasActiveFilter: boolean;
  selectedRating?: NineBoxRatingProps;
  selectedCell?: NineBoxCellSelectionProps;
}

function NineBoxActiveFilters({
  consideredPeriodLabel,
  hasActiveFilter,
  selectedRating,
  selectedCell,
}: NineBoxActiveFiltersProps) {
  if (!consideredPeriodLabel && !hasActiveFilter) {
    return null;
  }

  return (
    <Flex align="center" justify="space-between" width="full" pl="1" minH="1.25rem" gap="3">
      <Text textStyle="caption1-medium" color="gray.500" data-testid="ninebox-considered-period">
        {consideredPeriodLabel ? `Período considerado: ${consideredPeriodLabel}` : ''}
      </Text>

      {hasActiveFilter ? (
        <Flex align="center" gap="2" flexWrap="wrap" justify="flex-end" data-testid="ninebox-active-filters">
          {selectedRating && (
            <Badge
              borderRadius="base"
              py="1px"
              px="1.5"
              borderWidth="1px"
              borderColor="gray.100"
              bgColor="gray.100"
              color="gray.900"
            >
              {`Rating: ${resolveRatingLabel(selectedRating)}`}
            </Badge>
          )}

          {selectedCell && (
            <Badge
              borderRadius="base"
              py="1px"
              px="1.5"
              borderWidth="1px"
              borderColor="gray.100"
              bgColor="gray.100"
              color="gray.900"
            >
              {`Ano: ${selectedCell.year}`}
            </Badge>
          )}
        </Flex>
      ) : (
        <Flex />
      )}
    </Flex>
  );
}

export default NineBoxActiveFilters;
